import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { ListContainer } from '~/components/PageLayout';
import { DeviceScheduleDocument } from '../queries/schedule.generated';
import { Layout, ScheduleList } from './components';

export const DeviceSchedule = () => {
  const params = useParams<{ deviceId: string }>();
  const deviceId = Number(params.deviceId);

  const { data } = useQuery(DeviceScheduleDocument, {
    variables: { deviceId },
  });

  const device = data?.device;

  return (
    <Layout noPadding>
      <ListContainer>{device && <ScheduleList device={device} />}</ListContainer>
    </Layout>
  );
};
